import { render, staticRenderFns } from "./FiltersButton.vue?vue&type=template&id=adf06bba&scoped=true&"
import script from "./FiltersButton.vue?vue&type=script&lang=js&"
export * from "./FiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./FiltersButton.vue?vue&type=style&index=0&id=adf06bba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf06bba",
  null
  
)

export default component.exports